export function NoopCell() {
  return null;
}
